
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import ContaModal from './ContaModal.vue';
import ServicoConta from '@/servicos/Cadastros/Financeiro/ServicoConta';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'Conta',
  components: {
    TelaPadraoCrud,
    ContaModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoConta = new ServicoConta();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = false;
    crudBase.estrutura.botaoPrincipalAcao = 'Nova';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da conta';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Tipo', dataIndex: 'descricaoTipo', key: 'Tipo', position: 2, visible: true, ordering: true, width: 150,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 3, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 4, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'Ações', key: 'acoes', position: 5, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoConta,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      refCrud,
    };
  },
});
